"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var babylonjs_materials_1 = require("babylonjs-materials");
var vf_config_manager_1 = require("./vf-config-manager");
var const_1 = require("./const");
var VFMaterialFactory = (function () {
    function VFMaterialFactory() {
    }
    VFMaterialFactory.reset = function () {
        this.MaterialInstances = {};
    };
    VFMaterialFactory.GetEventTriggerMaterial = function (scene, textureHash, color) {
        if (textureHash === void 0) { textureHash = 0; }
        if (color === void 0) { color = null; }
        return __awaiter(this, void 0, void 0, function () {
            var name, textureUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = "vfEventTriggerMat"
                            + (textureHash === 0 ? "" : textureHash.toString())
                            + (color === null ? "" : color.r + "-" + color.g + "-" + color.b + "-" + color.a);
                        return [4, scene.getTextureUrlByHash(textureHash, vf_config_manager_1.default.GetConfig().eventTriggerImageURL)];
                    case 1:
                        textureUrl = _a.sent();
                        return [2, this.GetOrCreateMaterial(name, function () {
                                var texture = new babylonjs_1.Texture(textureUrl, scene);
                                return new VFUIMaterial(name, scene, texture, color);
                            })];
                }
            });
        });
    };
    VFMaterialFactory.GetEgoTriggerMaterial = function (scene, textureHash, color) {
        if (textureHash === void 0) { textureHash = 0; }
        if (color === void 0) { color = null; }
        return __awaiter(this, void 0, void 0, function () {
            var name, textureUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = "vfEgoTriggerMat"
                            + (textureHash === 0 ? "" : textureHash.toString())
                            + (color === null ? "" : color.r + "-" + color.g + "-" + color.b + "-" + color.a);
                        return [4, scene.getTextureUrlByHash(textureHash, vf_config_manager_1.default.GetConfig().egoTriggerImageURL)];
                    case 1:
                        textureUrl = _a.sent();
                        return [2, this.GetOrCreateMaterial(name, function () {
                                var texture = new babylonjs_1.Texture(textureUrl, scene);
                                return new VFUIMaterial(name, scene, texture, color);
                            })];
                }
            });
        });
    };
    VFMaterialFactory.GetDummyMaterial = function (scene) {
        var name = "dummy";
        return this.GetOrCreateMaterial(name, function () {
            var material = new VFUIMaterial(name, scene);
            material.emissiveColor = babylonjs_1.Color3.Green();
            return material;
        });
    };
    VFMaterialFactory.GetPlacementIndicatorMaterial = function (scene) {
        var name = "vfPlacementIndicatorMat";
        return this.GetOrCreateMaterial(name, function () {
            var texture = new babylonjs_1.Texture(vf_config_manager_1.default.GetConfig().arPlacementIndicatorURL, scene);
            return new VFUIMaterial(name, scene, texture);
        });
    };
    VFMaterialFactory.GetDropShadowMaterial = function (scene) {
        var name = "vfARShadowMat";
        return this.GetOrCreateMaterial(name, function () {
            var texture = new babylonjs_1.Texture(vf_config_manager_1.default.GetConfig().groundTextureURL, scene);
            texture.hasAlpha = true;
            var mat = new babylonjs_1.BackgroundMaterial(name, scene);
            mat.diffuseTexture = texture;
            mat.alpha = const_1.default.AR_DROP_SHADOW_OPACITY;
            mat.useRGBColor = false;
            mat.primaryColor = babylonjs_1.Color3.Black();
            return mat;
        });
    };
    VFMaterialFactory.GetShadowPlaneMaterial = function (scene) {
        var name = "vfShadowPlaneMat";
        return this.GetOrCreateMaterial(name, function () {
            var mat = new babylonjs_materials_1.ShadowOnlyMaterial(name, scene);
            mat.activeLight = scene.lights.find(function (light) { return light instanceof babylonjs_1.ShadowLight; });
            mat.alpha = const_1.default.AR_SHADOW_PLANE_OPACITY;
            return mat;
        });
    };
    VFMaterialFactory.GetMaterialWithTexture = function (scene, identifier, textureUrl) {
        var name = "material-" + identifier;
        return this.GetOrCreateMaterial(name, function () {
            var texture = new babylonjs_1.Texture(textureUrl, scene);
            return new VFUIMaterial(name, scene, texture);
        });
    };
    VFMaterialFactory.GetMaterialWithColorAndTexture = function (scene, identifier, texture, color) {
        var name = identifier + "_" + color.r + "-" + color.g + "-" + color.b + "-" + color.a;
        return this.GetOrCreateMaterial(name, function () {
            return new VFUIMaterial(name, scene, texture, color);
        });
    };
    VFMaterialFactory.GetOrCreateMaterial = function (name, createFunc) {
        if (!this.MaterialInstances[name]) {
            this.MaterialInstances[name] = createFunc();
        }
        return this.MaterialInstances[name];
    };
    VFMaterialFactory.MaterialInstances = {};
    return VFMaterialFactory;
}());
exports.default = VFMaterialFactory;
var VFUIMaterial = (function (_super) {
    __extends(VFUIMaterial, _super);
    function VFUIMaterial(name, scene, texture, color) {
        var _this = _super.call(this, name, scene) || this;
        _this.disableLighting = true;
        _this.emissiveColor = babylonjs_1.Color3.White();
        if (texture) {
            _this.diffuseTexture = texture;
            _this.diffuseTexture.hasAlpha = true;
            _this.opacityTexture = _this.diffuseTexture;
        }
        if (color) {
            _this.alpha = color.a;
            var colorRGB = babylonjs_1.Color3.FromInts(color.r, color.g, color.b);
            _this.diffuseTexture = texture;
            _this.diffuseColor = colorRGB;
            _this.emissiveColor = colorRGB;
        }
        return _this;
    }
    return VFUIMaterial;
}(babylonjs_1.StandardMaterial));
